import {useMutation, useQueryClient} from "@tanstack/react-query";
import {claimUbiiPagoOrphanService} from "@/services/wallet/ubiiPagoOrphanClaim.service";
import {
  getUbiiPagoClaimErrorKey,
  // For validation of successful payload
} from "@/utils/ubii-pago-orphan-claim.util";

export class UbiiPagoOrphanClaimHttpError extends Error {
  constructor(httpStatus) {
    const messageKey = getUbiiPagoClaimErrorKey(httpStatus);
    super(messageKey);
    this.name = "UbiiPagoOrphanClaimHttpError";
    this.httpStatus = httpStatus;
    this.messageKey = messageKey;
  }
}

const useClaimUbiiPagoOrphan = () => {
  const queryClient = useQueryClient();

  const {mutateAsync, isPending, reset} = useMutation({
    mutationFn: async payload => {
      try {
        const response = await claimUbiiPagoOrphanService(payload);
        const claimData = response?.data?.data;

        if (
          !claimData ||
          typeof claimData.amount !== "number" ||
          typeof claimData.new_balance !== "number" ||
          typeof claimData.transaction_id !== "string"
        ) {
          throw new UbiiPagoOrphanClaimHttpError(500);
        }

        return claimData;
      } catch (err) {
        if (err instanceof UbiiPagoOrphanClaimHttpError) throw err;

        const httpStatus = err?.response?.status;
        if (typeof httpStatus === "number") {
          throw new UbiiPagoOrphanClaimHttpError(httpStatus);
        }

        throw new UbiiPagoOrphanClaimHttpError();
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ["userWallet"]});
    },
  });

  return {
    claimOrphan: mutateAsync,
    isPending,
    reset,
  };
};

export default useClaimUbiiPagoOrphan;

